import { render, staticRenderFns } from "./Pwd.vue?vue&type=template&id=588f051a"
import script from "./Pwd.vue?vue&type=script&lang=js"
export * from "./Pwd.vue?vue&type=script&lang=js"
import style0 from "./Pwd.vue?vue&type=style&index=0&id=588f051a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports